import homepageSection from './fragment-homepage-section'
import link from './fragment-link'
import footerCTA from './fragment-footer-cta'
import seo from './fragment-seo'

export default /* graphql */ `
query($preview: Boolean) {
  specialPages(preview: $preview, id:"3jAyqrQ9kag81DwwhxGiU8") {
    title
    slug
    seo {
      ...seo
    }
    heroEyebrow
    heroHeadline
    sectionsCollection {
      total
      items {
        ...homepageSection
      }
    }
    footerCtAsCollection(limit: 1) {
      total
      items {
        ...footerCTA
      }
    }
  }
}

${homepageSection}
${link}
${footerCTA}
${seo}
`
